import { carSafety } from '@constants/values/equipment'

const bezpieczenstwo = {
    name: 'bezpieczenstwo',
    options: carSafety,
    t: 'Bezpieczeństwo',
    toggle: true,
    type: 'multi-checkbox',
}

export default bezpieczenstwo